RivalIQ.apps.Overview.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const SocialPostsApp = RivalIQ.apps.SocialPosts;

    const TextInsight = RivalIQ.views.ItemView.mixin({
        className: 'row',
        template: '#overviewTopPostsInsightsTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            leftInsight: '.x-insight-left',
            rightInsight: '.x-insight-right'
        },

        serializeData: function () {
            const me = this;

            const observations = me.getOption('observations');
            return {
                firstInsight: observations[0],
                secondInsight: observations[1]
            };
        }
    });

    const SingleChannelTopPosts = RivalIQ.views.LayoutView.mixin({
        template: '#overviewSingleChannelTopPostsTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        regions: {
            table: '.x-table-region',
            observations: '.x-observations-region'
        },

        onRenderLoaded: function () {
            const me = this;

            me.showTable();
            me.showTextObservations();
        },

        showTextObservations: function () {
            const me = this;

            if (me.postObservations.length) {
                me.observations.show(new TextInsight({
                    observations: me.postObservations
                }));
            }
        },

        loadData: function () {
            const me = this;
            const definition = me.dashboardModel.metrics.at(0);
            const fetches = [
                definition.fetch(),
                RivalIQ.data.companyData.fetchPresences()
            ];

            return $.when.apply($, fetches).then(function (metric, companyData) {
                me.metric = metric;
                const data = metric.data;
                const focusCompanyPosts = _.get(data, ['dimensions', 'post', 'buckets']);
                me.focusCompanyPosts = _(focusCompanyPosts)
                    .map(function (post) {
                        return new RivalIQ.models.Post(post, {
                            companyData: companyData
                        });
                    })
                    .value();

                me.postObservations = data.observations;
                me.data = data;
            });
        },

        showTable: function () {
            const me = this;

            const widgetType = Marionette.Dashboard.widgets.get(RivalIQ.enums.widgetTypes.SOCIAL_POSTS);
            const Widget = new widgetType(me.dashboardModel, {
                props: {
                    limit: me.getProp('limit'),
                    layout: 'grid_square_with_details',
                    withObservations: true,
                    companyData: me.companyData,
                    metric: me.metric
                }
            });
            me.table.showWidget(Widget);
        }
    });

    const SingleChannelTopPostsWidget = RivalIQ.apps.Dashboard.models.Widget.extend({
        view: SingleChannelTopPosts,

        processProps: function () {
            const me = this;

            me.metrics = me.curation.metrics;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.OVERVIEW_SINGLE_CHANNEL_TOP_POSTS, SingleChannelTopPostsWidget);

    const TopPerformingPostsUsage = RivalIQ.views.LayoutView.mixin({
        template: '#overviewTopPostsUsageTemplate',
        className: 'top-performing-posts-usage',
        childView: RivalIQ.apps.Dashboard.views.Widget,

        regions: {
            container: '.x-top-performing-posts'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            normalizeHeights: RivalIQ.apps.Dashboard.mixins.NormalizeHeights
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        onBeforeRenderLoaded: function () {
            const me = this;

            me.container.showWidget(me.dashboardModel.getWidget('top-performing-posts'));
        }
    });

    const FooterView = RivalIQ.apps.Dashboard.views.PanelFooter.extend({
        template: '#overviewWidgetFooterTemplate',
        serializeData: function () {
            const me = this;

            return {
                // redirect to social posts detail view
                footerText: 'View social post analysis',
                footerUrl: `${_.compact(['/posts', me.getProp('channel')]).join('/')}?ref=overview-link`
            };
        }
    });

    function getFilenameTitle() {
        return 'top performing posts';
    }

    function getBaseMetric(curation) {
        const timePeriod = RivalIQ.state.view.get('timePeriod');
        return new RivalIQ.models.MetricDefinition({
            concept: RivalIQ.metrics.descriptions.SOCIAL_POST.id,
            dimensions: ['post'],
            orderBy: RivalIQ.apps.SocialPosts.utils.getOrderBy(curation),
            withObservations: true,
            compareStartDate: timePeriod.comparePeriodStart,
            compareEndDate: timePeriod.comparePeriodEnd
        });
    }

    const TopPerformingPostsWidget = RivalIQ.apps.Dashboard.models.Widget.mixin({
        mixins: {
            brokenThumbnailHandler: RivalIQ.utils.BrokenThumbnailHandler
        },
        title: function () {
            const me = this;
            const focusCompany = RivalIQ.state.landscape.getCompanyById(me.getProp('focusCompanyId'));
            const companyName = (focusCompany ? focusCompany.get('name') : '');
            const companyNamePossessive = App.utils.makePossessive(companyName);
            const channel = me.getProp('channel');
            if (channel) {
                switch (channel) {
                    case RivalIQ.enums.channels.TWITTER:
                    case RivalIQ.enums.channels.TIKTOK:
                        return `${companyNamePossessive} Top ${_.upperFirst(RivalIQ.data.channels.get(channel).get('postName'))}s`;

                    default:
                        return RivalIQ.str('overview_top_performing_posts_widget_title', companyNamePossessive, RivalIQ.data.channels.get(channel).get('name'));
                }
            }
            return RivalIQ.str('overview_cross_channel_top_performing_posts_widget_title', companyNamePossessive);
        },

        description: function () {
            const me = this;

            const channel = me.getProp('channel');
            const postWord = RivalIQ.data.channels.get(channel).get('postName');
            return (channel ? RivalIQ.str('overview_single_channel_top_performing_posts_widget_description', postWord) : RivalIQ.strings.overview_cross_channel_top_performing_posts_widget_description);
        },

        processProps: function (props) {
            const me = this;

            _.defaults(props, {
                sortOrder: 1,
                showPostTags: false
            });

            if (!me.metric) {
                me.metric = me.getBaseMetric(me);
            }

            SocialPostsApp.utils.updateMetric(me.metric, props);

            me.metrics = me.metricsCollection = RivalIQ.models.MetricDefinition.buildMetric(me.metric, props.metrics);

            return props;
        },
        view: TopPerformingPostsUsage,
        widgetDefinitions: function () {
            const me = this;

            const props = me.getProps();
            const channel = props.channel;

            let widgetId;
            let widgetProps;
            if (channel) {
                widgetId = RivalIQ.enums.widgetTypes.OVERVIEW_SINGLE_CHANNEL_TOP_POSTS;
                widgetProps = {
                    redactEngagementLift: true,
                    orderBy: RivalIQ.apps.SocialPosts.utils.getOrderBy(me)
                };
            } else {
                widgetId = RivalIQ.enums.widgetTypes.OVERVIEW_CROSS_CHANNEL_TOP_POSTS;
                widgetProps = {
                    redactEngagementLift: true,
                    limit: me.getProp('limit'),
                    layout: 'grid_square_with_details',
                    metrics: [
                        {
                            property: 'engagement_total',
                            dimensions: ['post']
                        }
                    ],
                    metric: me.metric
                };
            }

            return [
                {
                    instanceId: 'top-performing-posts',
                    widgetId: widgetId,
                    props: widgetProps
                }
            ];
        },
        pdfView: SocialPostsApp.views.PdfPanel,
        pngView: SocialPostsApp.views.PngPanel,
        exportFormats: [
            RivalIQ.enums.exportFormat.PDF,
            RivalIQ.enums.exportFormat.PPT,
            RivalIQ.enums.exportFormat.PNG
        ],
        propsToSerializeForExport: SocialPostsApp.utils.widgetExportProps,
        getExportTitle: SocialPostsApp.utils.exportTitle,
        getExportSubtitle: SocialPostsApp.utils.exportSubtitle,
        getPptSubtitle: SocialPostsApp.utils.pptSubtitle,
        getSlideElements: SocialPostsApp.utils.getSlideElements,
        footerView: FooterView,
        getFilenameTitle: getFilenameTitle,
        getBaseMetric: getBaseMetric,
        getExportOrientation: function (format) {
            const me = this;
            const orientation = me.getProp('orientation');

            if (orientation) {
                return orientation;
            }

            if (format === RivalIQ.enums.exportFormat.PPT || !me.getProp('channel')) {
                return RivalIQ.enums.orientation.LANDSCAPE;
            }

            return RivalIQ.enums.orientation.PORTRAIT;
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.OVERVIEW_TOP_POSTS, TopPerformingPostsWidget);
});
